import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

import { E2E_ATTRIBUTES } from '@shared/types/enums/e2e-attributes.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class LoaderComponent {
  @Input() public isDefaultSize = false;
  @Input() public message = '';
  @Input() public noBackground = false;
  @Input() public isBiggerFont = false;
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  @HostBinding('class.no-background') get noBackgroundClass() {
    return this.noBackground;
  }

  public E2E_ATTRIBUTES = E2E_ATTRIBUTES;
  public constructor() {}
}
